import * as React from "react";
import { Burger } from "./Burger";
import { CommonBurgerProps } from "./types";

export const Spin: React.FC<CommonBurgerProps> = (props) => (
  <Burger
    {...props}
    render={(o) => (
      <div
        className="hamburger-react"
        aria-label={o.label}
        aria-expanded={o.isToggled}
        data-testid="spin"
        style={{
          ...o.burgerStyles,
          transform: `${
            o.isToggled ? `rotate(${180 * (o.isLeft ? -1 : 1)}deg)` : "none"
          }`,
        }}
        tabIndex={0}
      >
        <div
          style={{
            ...o.barStyles,
            width: `${o.width}px`,
            top: `${o.topOffset}px`,
            transition: `${o.time}s ${o.easing}`,
            transform: `${
              o.isToggled
                ? `rotate(${45 * (o.isLeft ? -1 : 1)}deg) translate(${
                    o.move * (o.isLeft ? -1 : 1)
                  }px, ${o.move}px)`
                : "none"
            }`,
          }}
        />

        <div
          style={{
            ...o.barStyles,
            width: `${o.width}px`,
            top: `${o.topOffset + o.barHeight + o.margin}px`,
            transition: `${o.time}s ${o.easing}`,
            opacity: `${o.isToggled ? "0" : "1"}`,
          }}
        />

        <div
          style={{
            ...o.barStyles,
            width: `${o.width}px`,
            top: `${o.topOffset + o.barHeight * 2 + o.margin * 2}px`,
            transition: `${o.time}s ${o.easing}`,
            transform: `${
              o.isToggled
                ? `rotate(${45 * (o.isLeft ? 1 : -1)}deg) translate(${
                    o.move * (o.isLeft ? -1 : 1)
                  }px, ${o.move * -1}px)`
                : "none"
            }`,
          }}
        />
      </div>
    )}
  />
);
